import api from 'api'

export type DiffColumbiaTimesheetParams = {
  vndlyInstanceId: number
  startDate: string
  endDate: string
  timesheet: File
}

export type ColumbiaTimesheetUnmatchedSide =
  | 'missing_in_workwhile'
  | 'missing_in_vndly'

export type ColumbiaTimesheetHoursChange = {
  date: string
  workwhileHours: string
  vndlyHours: string
}

export type ColumbiaTimesheetRowDiff = {
  rowNumber: number
  workerName: string
  unit: string
  address: string
  positionName: string
  hoursChanges: ColumbiaTimesheetHoursChange[]
}

export type ColumbiaTimesheetUnmatchedRow = {
  issues: ColumbiaTimesheetUnmatchedSide[]
  workerName: string
  unit: string
  address: string
  positionName: string
  rowNumber: number | null
}

export type DiffColumbiaTimesheetResponse = {
  startDate: string
  endDate: string
  rowDiffs: ColumbiaTimesheetRowDiff[]
  unmatchedRows: ColumbiaTimesheetUnmatchedRow[]
}

export const diffColumbiaTimesheet = async ({
  vndlyInstanceId,
  startDate,
  endDate,
  timesheet,
}: DiffColumbiaTimesheetParams): Promise<DiffColumbiaTimesheetResponse> => {
  const formData = new FormData()
  formData.append('timesheet', timesheet)

  const result = await api.post<DiffColumbiaTimesheetResponse>(
    '/admin/vndly/columbia/timesheet/diff',
    formData,
    {
      params: {
        vndlyInstanceId,
        startDate,
        endDate,
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return result.data
}
